export const SET_COMPLETED_WORK_ORDER_LIST = 'SET_COMPLETED_WORK_ORDER_LIST'
export const SET_COMPLETED_AUTH = 'SET_COMPLETED_AUTH'
